var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagAzerbaijan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1691_40751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0001C24 10.5323 23.736 9.12615 23.2536 7.82621L12 7.30444L0.746391 7.82616C0.264047 9.12615 0 10.5323 0 12.0001C0 13.4679 0.264047 14.8741 0.746391 16.174L12 16.6958L23.2536 16.174C23.736 14.8741 24 13.4679 24 12.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738H0.746094C2.44161 20.7434 6.84012 23.9999 11.9997 23.9999Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0C6.84013 0 2.44161 3.2565 0.746094 7.82611Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2605 15.3914C10.3875 15.3914 8.86915 13.873 8.86915 12.0001C8.86915 10.1272 10.3875 8.6088 12.2605 8.6088C12.8444 8.6088 13.3939 8.75645 13.8737 9.01642C13.121 8.28044 12.0919 7.82617 10.9561 7.82617C8.6509 7.82617 6.78223 9.69489 6.78223 12.0001C6.78223 14.3052 8.65095 16.174 10.9561 16.174C12.0919 16.174 13.1211 15.7197 13.8737 14.9837C13.3939 15.2438 12.8444 15.3914 12.2605 15.3914Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8693 9.65234L15.3185 10.9157L16.5295 10.34L15.9538 11.5509L17.2171 12.0002L15.9538 12.4494L16.5295 13.6604L15.3185 13.0847L14.8693 14.348L14.4202 13.0847L13.2091 13.6604L13.7849 12.4494L12.5215 12.0002L13.7849 11.5509L13.2091 10.34L14.4202 10.9157L14.8693 9.65234Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1691_40751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAzerbaijan);
export default __webpack_public_path__ + "static/media/flag-azerbaijan.84583833627cc210d041d98fd3a348bd.svg";
export { ForwardRef as ReactComponent };